import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import FireBase from '../../firebase/firebase';
import { useAuth } from '../../context/UserAuth';

const userObj = {
  book: '',
  author: '',
  status: '',
};

export default function Profile() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [userData, setUserData] = useState(userObj);
  const [books, setBooks] = useState([]);

  const _onChange = (e) => {
    setUserData((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));
  };

  /**
   ** getAllBooks
   */
  const allBooks = async () => {
    const data = await FireBase.getAllBooks();
    // console.log(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    setBooks(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };
  useEffect(() => {
    allBooks();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (userData.book === '' || userData.author === '' || userData.status === '')
      return alert('All Filed Are Required!!');

    //! add a new book
    FireBase.newBook(userData);
    // FireBase.newBook({ book: userData.book, author: userData.author, status: userData.status });

    //! clear
    setUserData(userObj);
  };

  //! delete
  const deleteHandler = (id) => {
    FireBase.deleteBook(id);
    allBooks();
  };

  ///////////////////////////////////////////////
  return (
    <>
      <div className='container text-center mt-5'>
        {user && (
          <div className='bg-secondary p-3 m-3'>
            <strong>email : {user.email}</strong>
          </div>
        )}
        <form>
          <div className='mb-3'>
            <input
              type='text'
              className='form-control'
              id='book'
              aria-describedby='emailHelp'
              placeholder='Book Name'
              required
              onChange={_onChange}
              name='book'
              value={userData.book}
            />
          </div>
          <div className='mb-3'>
            <input
              type='text'
              className='form-control'
              id='author'
              placeholder='Author Name'
              required
              onChange={_onChange}
              name='author'
              value={userData.author}
            />
          </div>
          <div className='mb-3'>
            <select
              id='disabledSelect'
              className='form-select'
              onChange={_onChange}
              name='status'
              value={userData.status}
              required
            >
              <option>Select Status</option>
              <option value='Available'>Available</option>
              <option value='UnAvailable'>UnAvailable</option>
            </select>
          </div>
          <hr />
          <button type='submit' className='btn btn-primary' onClick={handleSubmit}>
            Submit
          </button>
        </form>
      </div>
      <div className='container mt-5'>
        <Table striped bordered hover variant='dark'>
          <thead>
            <tr>
              {/* <th>S.NO.</th> */}
              <th>Books</th>
              <th>Author</th>
              <th>Status</th>
              <th>Actions</th>
              <th>Actions</th>
            </tr>
          </thead>
          {books.map((item, index) => {
            return (
              <tbody key={item.id}>
                <tr>
                  <td>{index + 1}</td>
                  <td>{item.book}</td>
                  <td>{item.author}</td>
                  <td>{item.status}</td>
                  <td>
                    <button className='btn btn-info' onClick={() => navigate(`/update/${item.id}`)}>
                      Edit
                    </button>
                    <button className='btn btn-danger ms-3 my-1' onClick={() => deleteHandler(item.id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            );
          })}
        </Table>
      </div>
    </>
  );
}
